// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".61e5918938ec43ccaa73e4e2bc2fe99b.js";
};